module.exports = __webpack_public_path__ + "img/cusBg.45ecb7ef.png";